/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureUserOutputCashModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    outputAccountsType: lc.get(data, 'payout_accounts_type'),
    accountNumber: lc.get(data, 'account_number'),
    details: lc.get(data, 'details'),
    userId: lc.get(data, 'user_id'),
    status: lc.get(data, 'status'),
    desc: lc.get(data, 'desc'),
    serialNumber: lc.get(data, 'serial_number'),
    sum: lc.get(data, 'sum'),
    totalSum: lc.get(data, 'total_sum'),
    totalCurrency: lc.get(data, 'total_currency'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at'),
    date: lc.get(data, 'date'),
    descOutputAccountsType: lc.get(data, 'desc_payout_accounts_type'),
    statusDesc: lc.get(data, 'status_desc'),
    detailDesc: lc.get(data, 'detail_desc')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/services/UserOutputCashService/restructuring/index.js